import { useState, useEffect, useCallback } from 'react';
import { CopaGroup, getWorldCupStandings } from '@/services/api/espn-football';

export function useWorldCupStandings() {
  const [groups, setGroups] = useState<CopaGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const fetchStandings = useCallback(async () => {
    try {
      const data = await getWorldCupStandings();
      setGroups(data);
      setError(null);
      setLastUpdated(new Date());
    } catch (e: any) {
      setError(e.message ?? 'Erro ao buscar classificação');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStandings();
    const timer = setInterval(fetchStandings, 300_000); // 5 min
    return () => clearInterval(timer);
  }, [fetchStandings]);

  return { groups, loading, error, refresh: fetchStandings, lastUpdated };
}
